module.exports = __webpack_public_path__ + "img/vidlogo_Cheddar.74ccf8bd.jpg";